import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';
import Button from '../../../components/atoms/forms/Button';

// Orange "recommended action" callout: title + body + warning-colored CTA.
// Shared by LineHaulSection, HeadcountSection, and MissedStopsReviewSection —
// each passes its own copy and test ids. `margin` picks which side gets the
// fieldGap: 'below' for callouts sitting mid-form, 'above' for callouts that
// close out a section.

const StyledDiv = styledComponent('div', {
  '& .rac-callout': {
    background: theme.colors.cautionBg,
    borderLeft: `4px solid ${theme.colors.caution}`,
    padding: theme.spacing.bodyPadding,
    borderRadius: theme.radii.input,
  },
  '& .rac-margin-below': {
    marginBottom: theme.spacing.fieldGap,
  },
  '& .rac-margin-above': {
    marginTop: theme.spacing.fieldGap,
  },
  '& .rac-title': {
    fontWeight: theme.fontWeights.semibold,
    color: theme.colors.warningText,
    marginBottom: theme.spacing.labelGap,
  },
  '& .rac-body': {
    fontSize: theme.typography.body.fontSize,
    color: theme.colors.text,
    marginBottom: theme.spacing.fieldGap,
  },
});

function RecommendedActionCallout({
  title,
  body,
  ctaLabel,
  onCta,
  testId,
  ctaTestId,
  margin,
}) {
  return (
    <StyledDiv>
      <div className={`rac-callout rac-margin-${margin}`} data-testid={testId}>
        <div className="rac-title">{title}</div>
        <div className="rac-body">{body}</div>
        <Button variant="warning" onClick={onCta} dataTestId={ctaTestId}>
          {ctaLabel}
        </Button>
      </div>
    </StyledDiv>
  );
}

RecommendedActionCallout.propTypes = {
  title: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  onCta: PropTypes.func.isRequired,
  testId: PropTypes.string,
  ctaTestId: PropTypes.string,
  margin: PropTypes.oneOf(['below', 'above']),
};

RecommendedActionCallout.defaultProps = {
  testId: undefined,
  ctaTestId: undefined,
  margin: 'below',
};

export default RecommendedActionCallout;
